/**
 * @format
 */

import React from 'react';
import { useLeaderboard } from '../hooks/useLeaderboard';
import { AgentLeaderboardFilterInput } from '../types/leaderboard.types';
import Podium from '../components/Podium';
import LeaderboardTable from '../components/LeaderboardTable';

interface LeaderboardContainerProps {
  filter?: AgentLeaderboardFilterInput;
}

/**
 * Container component for both Podium and Leaderboard Table
 * Fetches leaderboard data once and passes to both components
 */
const LeaderboardContainer: React.FC<LeaderboardContainerProps> = ({ filter }) => {
  // Fetch leaderboard data once with filter
  const { data, loading, error } = useLeaderboard(filter);

  return (
    <>
      <Podium data={data} loading={loading} error={error} />
      <div style={{ marginTop: '20px' }}>
        <LeaderboardTable data={data} loading={loading} error={error} />
      </div>
    </>
  );
};

export default LeaderboardContainer;
